import React, { useState, useRef, useEffect } from 'react';
import { useSelector, useDispatch } from "react-redux";
import { Container, Row, Col, Form } from 'react-bootstrap';
import { useTranslation } from "react-i18next";


import BirthdayField from '../BirthdayField'
import Button from '../Button';
import { isValidDOB } from '../BirthdayField'
import CommonModal from '../CommonModal';
import ExampleDob from './exampleDob'
import ExampleLaser from './exampleLaser'
import Header from '../Header';
import FaceCapture from '../PageFaceCapture'
import PageWrapper from '../PageWrapper';

import { documentsGet, documentUpdate } from "logic/actions/api/document";
import { 
	setDataDOPACheck, 
	setTwoElementCheck,
	countDopaRetries,
	resetDopaCheck,
	setResponseDopa,
} from 'logic/actions/dopaCheck';
import {
	applicationSubmitForDopa,
	applicationSubmitTwoElementForDopa,
	applicationCheckDopaResult,

} from 'logic/actions/api/dopaCheck';

import {
    logEvent,
} from "logic/eventLogger";
import { getTimePassed, startEventTimer } from "logic/stepTimers";


import alertSolid from '../../../assets/icons/figma/alert-solid.svg'
import Male from '../../../assets/icons/figma/man-icon.svg'
import Female from '../../../assets/icons/figma/woman-icon.svg'
import correctIcon from '../../../assets/icons/figma/correct-icon.svg'
import helpIcon from '../../../assets/icons/figma/helpIcon.svg'

import './index.css';
import ProcessingOverlay from 'logic/loading';
import { alertUser } from 'logic/eventBeforeunload';

const BE_OFFSET = 543; 
export default function EkycDopaForm(props) {

	const {
		documentCapture,
		dopaCheck,
		showNewTemplate,
	} = useSelector((state) => ({
		documentCapture: state.documentCapture,
		dopaCheck: state.dopaCheck,
		showNewTemplate: state.setApplicationParams.showNewTemplate,
	}));
	const dispatch = useDispatch()

  const { t } = useTranslation();


	const dopaTimeInterval = useRef(null);
	

	const [form, setForm] = useState({
		id: '',
		firstName: '',
		middleName: '',
		lastName: '',
		gender: '',
		dob: '',
		laser: '',
		agree: false
	});

	const [hasInteracted, setHasInteracted] = useState(false);

	const [isSubmitting, setIsSubmitting] = useState(false);
	const [pending, setPending] = useState(true);

	const [showCorrectTips, setShowCorrectTips] = useState(false);
	const [currentPage, setCurrentPage] = useState("");

	// if yyyy0101 failed dopa, use yyyy0000 to try
	const [dopaAutoRetryStatus, setDopaAutoRetryStatus] = useState(false)

	const [defaultDopaCheckCountRetry, setDefaultDopaCheckCountRetry] = useState(5);
	const [dopaResultStatus, setDopaResultStatus] = useState(false)

	const countLeftRetry =
  	defaultDopaCheckCountRetry - dopaCheck.dopacheckRetries;


	const [modal, setModal] = useState({
		show: false,
		type: null,
	});

	const requiredFields = [
		"id",
		"firstName",
		"lastName",
		"gender",
		"dob",
		"laser"
	];

	const formatRule = {
		idcardRule: {
			pattern: '#-####-#####-##-#',
		},
		laserRule: {
			pattern: 'AA#-#######-##',
		},
	}

	const modalMap = {
		cannotVerify: {
			icon: alertSolid,
			title: "ไม่สามารถยืนยันข้อมูลของคุณได้",
			desc: "ข้อมูลของคุณไม่ตรงกับฐานข้อมูลของกรมการปกครอง ตรวจสอบบัตรประชาชน ของคุณอีกครั้ง โดยบัตรจะต้อง ไม่หมดอายุ หรือถูกยกเลิก",
			confirmText: "ตกลง",
			action: "retryVerify",
		},

		// Error attempt exceed maxtimes 6 (7th)
		expired: {
			icon: alertSolid,
			title: "คุณทำรายการเกินกำหนด",
			desc: "ข้อมูลของคุณไม่ตรงกับฐานข้อมูลของ กรมการปกครอง กรุณาตรวจสอบข้อมูล และเริ่มยืนยันตัวตนใหม่อีกครั้ง",
			confirmText: "ตกลง",
			action: "restartApp",
		},

		systemError: {
			icon: alertSolid,
			title: "ไม่สามารถดำเนินการต่อได้",
			desc: "ระบบตรวจสอบข้อมูลขัดข้องชั่วคราว กรุณาลองใหม่อีกครั้ง",
			confirmText: "ตกลง",
			action: "systemError",
		},

		laserExample: {
			title: "ตัวอย่าง",
			showFooter: false,
			layout: "example",
			content: <ExampleLaser />,
		},

		dobExample: {
			title: "ตัวอย่าง",
			showFooter: false,
			layout: "text",
			content: <ExampleDob />
		}

	};

	const config = modalMap[modal.type] || {};

	const fieldMap = {

		//id
		'Document Number': (val, ctx) => {
			ctx.id = formatByPattern(val.value, formatRule.idcardRule.pattern) || '';
		},

		//firstName & lastName
		'Surname And Given Names (1054)': (val, ctx) => {
			const parts = val.value?.trim().split(' ') || [];
			ctx.firstName = parts?.[1] || '';
			ctx.lastName = parts?.[parts.length - 1] || '';
		},

		//dob
		'Date Of Birth': (val, ctx) => {
			ctx.dob = formatThaiDOB(val.value) ||  '';
		},

		//gender
		'Sex': (val, ctx) => {
			ctx.gender = normalizeGender(val.value) || '';
		},

		//laser
		'Identity Card Number': (val, ctx) => {
			ctx.id = val.value || '';
		},
	};

	const genderMap = {
		"M": "Male",
		"Mr.": "Male",
		"MALE": "Male",
		"Male": "Male",

		"F": "Female",
		"Ms.": "Female",
		"Mrs.": "Female",
		"Miss": "Female",
		"FEMALE": "Female",
		"Female": "Female"
	};

	const genderOptions = [
		{
			value: "Male",
			label: "ชาย",
			icon: Male
		},
		{
			value: "Female",
			label: "หญิง",
			icon: Female
		}
	];

	const openModal = (type) => {
		setModal({
			show: true,
			type
		});
	};

	const handleAction = (action) => {
		switch (action) {
			case "retryVerify":
				handleModalOnHide();
				break;

			case "restartApp":
				window.removeEventListener('beforeunload', alertUser)
				window.location.reload();
				break;

			case "systemError":
				handleModalOnHide()
				break;

			default:
				console.log("unknown action");
		}
	}

	const validateName = (value = '') => {
		return /^[ๅภถุึคูตจขชๆไำพะัีรนยบลฃฟหกดเ้่าสวงผปแอิืทมใฝฎฑธํ๊ณฯญฐฅฤฆฏโฌ็๋ษศซฉฮฺ์ฒฬฦ $-/:.-?{-~!"^_`\\]+$/.test(value);
	};

	const getError = (field) => {
		switch (field) {
			case 'firstName':
				return !form.firstName || !validateName(form.firstName);

			case 'lastName':
				return !form.lastName || !validateName(form.lastName);

			case 'id':
				return (
					!form.id ||
					!validateByPattern(form.id, formatRule.idcardRule.pattern)
				);

			case 'laser':
				return (
					!form.laser ||
					!validateByPattern(form.laser, formatRule.laserRule.pattern)
				);

			case 'dob':
				return (
					!form.dob ||
					form.dob.length !== 10 ||
					!isValidDOB(form.dob)
				);

			case 'gender':
				return !form.gender;

			default:
				return !form[field];
		}
	};

	const showError = (field) => {
		if (!hasInteracted) return false;
		return getError(field);
	};

	const isShowCorrectTips = () => {
		return requiredFields
			.filter(field => field !== "laser")
			.every(field => !getError(field));
	};

	const isFormValidAll = () => {
		return requiredFields.every(field => !getError(field));
	};


	const handleSubmit = () => {

		setPending(true);
		setHasInteracted(true);
		if(!isFormValidAll()) {
			setPending(false)
			return
		};
		documentPut();

	};

	const formatByPattern = (value, pattern) => {
		const clean = value.replace(/[^A-Za-z0-9]/g, "").toUpperCase();

		let result = "";
		let index = 0;

		for (let p of pattern) {
			if (p === "A") {
				while (index < clean.length && !/[A-Z]/.test(clean[index])) {
					index++;
				}
				if (index < clean.length) {
					result += clean[index++];
				} else break;
			}

			else if (p === "#") {
				while (index < clean.length && !/[0-9]/.test(clean[index])) {
					index++;
				}
				if (index < clean.length) {
					result += clean[index++];
				} else break;
			}

			else {
				if (index > 0) result += p;
			}
		}

		return result;
	}

	const validateByPattern = (value='', pattern) => {
		const clean = value.replace(/[^A-Za-z0-9]/g, "");

		const totalLength = pattern.replace(/[^A#]/g, "").length;

		if (clean.length !== totalLength) {
			return false
		}

		let i = 0;
		for (let p of pattern) {
			if (p === "A") {
				if (!/[A-Z]/.test(clean[i])) {
					return false
				}
				i++;
			} else if (p === "#") {
				if (!/[0-9]/.test(clean[i])) {
					return false
				}
				i++;
			}
		}

		return true;
	}

	const getCursorPos = (raw, formatted, cursorPos) => {
		const rawClean = raw.slice(0, cursorPos).replace(/[^A-Za-z0-9]/g, "");

		let count = rawClean.length;
		let pos = 0;

		for (let i = 0; i < formatted.length; i++) {
			if (/[A-Za-z0-9]/.test(formatted[i])) {
				count--;
				if (count <= 0) {
					pos = i + 1;
					break;
				}
			}
		}

		return pos;
	}

	const handlePatternChange = (e, pattern, field, form, setForm) => {
		const input = e.target;
		const raw = input.value;
		const cursorPos = input.selectionStart;

		const clean = raw.replace(/[^A-Za-z0-9]/g, "");

		const maxLength = pattern.replace(/[^A#]/g, "").length;

		if (clean.length > maxLength) return;

		const formatted = formatByPattern(raw, pattern);
		const newPos = getCursorPos(raw, formatted, cursorPos);

		setForm((prev) => ({
			...prev,
			[field]: formatted
		}));

		requestAnimationFrame(() => {
			input.setSelectionRange(newPos, newPos);
		});
	}

	// for display UI    1994-12-02 -> 02/12/2537
	const formatThaiDOB = (value) => {
    
		if (!value) return '';
		const str = String(value).trim();
		let d;

		// handle pure Number string
		if (/^\d{8}$/.test(str)) {
			const year = str.slice(0, 4);
			const month = str.slice(4, 6);
			const day = str.slice(6, 8);

			d = new Date(`${year}-${month}-${day}`);
		} else {
			d = new Date(str);
		}

		if (isNaN(d.getTime())) {
			return '';
		}

		const day = String(d.getDate()).padStart(2, '0');
		const month = String(d.getMonth() + 1).padStart(2, '0');
		const year = d.getFullYear() + BE_OFFSET;

		return `${day}/${month}/${year}`;

	};

	const normalizeGender = (title) => {
		return genderMap[title?.trim()] || "";
	};

	const selectGender = (value) => {
		console.log('09000900')
		setForm((prev) => ({
			...prev,
			gender: value
		}));
	};

	const reloadOCRData = () => {
		console.log(dopaCheck.customerData)
		setForm((pre) => ({
			...pre,
			// id: customerData.confirmedIdNumber,
			id: formatByPattern(
				dopaCheck.customerData.confirmedIdNumber || "",
				formatRule.idcardRule.pattern
			),
			firstName: dopaCheck.customerData.confirmedGivenNames,
			middleName: dopaCheck.customerData.middleName,
			lastName: dopaCheck.customerData.confirmedLastname,
			gender: normalizeGender(dopaCheck.customerData.gender),
			dob: formatThaiDOB(dopaCheck.customerData.birthOfDate),
			laser: formatByPattern(
				dopaCheck.customerData.confirmedLaser || '',
				formatRule.laserRule.pattern
			),
		}));
	}

	const getDocumentOCRData = async () => {
		logEvent("id_card_ocr_conirm_[get-data]", {
			start_time: window.performance.now(),
			response: null
		})

		await dispatch(documentsGet())
			.then((response) => {
				logEvent("id_card_ocr_conirm_[get-data]", {
					end_time: getTimePassed("id_card_ocr_conirm_[get-data]"),
					response: response
				})
				let visualZoneObject = response.data.visualZone
				let keys = Object.keys(visualZoneObject);
				let valueArray = [];
				keys.forEach(function (key) {
					valueArray.push(visualZoneObject[key]);
				});
				const result = {};
				valueArray.forEach((val) => {
					const handler = fieldMap[val.name];
					if (typeof handler === 'function') {
						handler(val, result);
					}
				});

				setForm(prev => ({
					...prev,
					...result
				}));

				setPending(false)
			})
			.catch((err) => {
				logEvent("id_card_ocr_conirm_[get-data]", {
					end_time: getTimePassed("id_card_ocr_conirm_[get-data]"),
					response: err
				})
				setPending(false)
			});
	}

	const documentPut = async () => {
		logEvent("id_card_ocr_conirm_[dopa-result]", {
			start_time: window.performance.now(),
			response: null
		})

		const [d, m, y] = form.dob.split('/');
		const ogYear = Number(y) - BE_OFFSET;
		const ogBirthday = `${ogYear}${m}${d}`
		let setDate = `${y}${m}${d}`
		if(dopaAutoRetryStatus) {
			setDate = `${m}` === '01' ? `${y}0000` : `${y}${m}00`
		}
		const uncroppedFirstPage = documentCapture.base64CroppedFirstPage;
		const uncroppedSecondPage = documentCapture.base64CroppedSecondPage;
		let updatedOCRFields = {
			confirmedGivenNames: form.firstName.trim(),
			confirmedLastname: form.lastName.trim(),
			middleName: form.middleName.trim(),
			confirmedLaser: form.laser.replace(/[^A-Za-z0-9]/g, ""),
			confirmedIdNumber: form.id.replace(/\D/g, ""),
			confirmedBirthdate: setDate,
			gender: form.gender,
			birthOfDate: ogBirthday,
		}
		dispatch(setDataDOPACheck(updatedOCRFields))
		dispatch(
			documentUpdate(
				uncroppedFirstPage,
				uncroppedSecondPage,
				documentCapture.documentType,
				updatedOCRFields
			)
		)
			.then((res) => {
				logEvent("id_card_ocr_conirm_[put-data]", {
					end_time: getTimePassed("id_card_ocr_conirm_[put-data]"),
					response: res
				})
				handleDopaCheckSubmit()
			})
			.catch((err) => {
				logEvent("id_card_ocr_conirm_[put-data]", {
					end_time: getTimePassed("id_card_ocr_conirm_[put-data]"),
					response: err
				})
				setPending(false)
				openModal('systemError')
			})

	}

	const handleDopaCheckSubmit = () => {
		if (dopaResultStatus) {
			handleDopaSuccess()
		} else {
			if (dopaCheck.dopacheckRetries > 2
			) {
				dopaCheckTwoElementSubmit()
				dispatch(setTwoElementCheck())
			} else {
				dopaCheckSubmit()
			}
		}
	}

	const handleDopaSuccess = () => {
		setTimeout(() => {
			setPending(false)
			setCurrentPage('FACE_CAPTURE')
		}, 200)
	}

	const submitDopa = (promise, logName) => {
		promise
			.then((response) => {
				logEvent(logName, {
					end_time: getTimePassed(logName),
					response: response,
				});

				dispatch(setResponseDopa(response.data));
				dopaResult();
			})
			.catch((err) => {
				logEvent(logName, {
					end_time: getTimePassed(logName),
					response: err,
				});
				setPending(false);
				openModal('systemError') //system error
			});
	};

	const dopaCheckSubmit = () => {

		submitDopa(
			dispatch(applicationSubmitForDopa()),
			"id_card_ocr_conirm_[dopa-submit]"
		);

	}

	const dopaCheckTwoElementSubmit = () => {
		submitDopa(
			dispatch(applicationSubmitTwoElementForDopa()), 
			"id_card_ocr_conirm_[dopa-two-element-submit]"
		);
	};

	const dopaResult = async () => {
		logEvent("id_card_ocr_conirm_[dopa-result]", {
			start_time: window.performance.now(),
			response: null
		})

		await dispatch(applicationCheckDopaResult())
			.then((response) => {
				logEvent("id_card_ocr_conirm_[dopa-result]", {
					end_time: getTimePassed("id_card_ocr_conirm_[dopa-result]"),
					response: response
				})

				const items = response?.data?.items;

				const res = items?.find(
					item => 
						item.result === 'COMPLETED' && 
						item.edcValues != null
				);

				if (!res) {
					setPending(false);
					openModal('systemError'); // system error
				}

				const resultCode = res.edcValues['resultCode']
				switch (resultCode) {
					case '0':
						setDopaResultStatus(true);
						dispatch(setResponseDopa(response.data));
						handleDopaSuccess();
						break;

					case '6':
						handleDopaSystemError()
						break;
				
					default:
						handleDopaCannotVerify()
						break;
				}

			})
			.catch(err => {
				setPending(false)
				openModal('systemError') //system error
			})

	}

	const handleDopaSystemError = () => {
			setPending(false)
			openModal('systemError') //system error
	}

	const handleDopaCannotVerify = () => {
		// Error attempt exceed Max times(6)
		const isRetryAvailable = dopaCheck.dopacheckRetries <= defaultDopaCheckCountRetry;
		const shouldAutoRetry = autoRecheckDopa(form.dob);

		if (shouldAutoRetry) {
			setDopaAutoRetryStatus(true);
			dopaContinueRecheck();
		}

		const modalType = isRetryAvailable ? 'cannotVerify' : 'expired';
		dispatch(countDopaRetries());
		setPending(false);
		openModal(modalType);
	};

	const dopaContinueRecheck = () => {
    if (dopaTimeInterval.current) {
      clearTimeout(dopaTimeInterval.current);
      dopaTimeInterval.current = null;
			setPending(false)
      return;
    }

    dopaTimeInterval.current = setTimeout(() => {
      documentPut();
    }, 0);
  };

	const autoRecheckDopa = (dob) => {
		const day = dob?.value?.split('/')?.[0]?.padStart(2, '0');
		return day === '01';
	};

	const handleModalOnHide = () => {
		if(dopaCheck.dopacheckRetries > defaultDopaCheckCountRetry + 1) {
			window.removeEventListener('beforeunload', alertUser)
			handleAction('restartApp');
		}
		setModal(prev => ({
			...prev,
			show: false,
		}));
	}

	useEffect(() => {
		if(showNewTemplate) {
			const formControlEL = document.querySelectorAll(".form-control");

			formControlEL.forEach(item => {
				item.style.fontSize = "16px";
			});
		}
	}, [])

	useEffect(() => {
    return () => {
      if (dopaTimeInterval.current) {
        clearTimeout(dopaTimeInterval.current);
      }
    };
  }, []);

	// load OCR data
	useEffect(() => {
		if (!dopaCheck.customerData) {
			console.log('customerData')
			getDocumentOCRData()
		}

		if(dopaCheck.customerData) {
			reloadOCRData();
			setHasInteracted(true)
			setPending(false)
		}

	}, [])

	useEffect(() => {
		setShowCorrectTips(isShowCorrectTips());
	}, [form])

	if(currentPage=== 'FACE_CAPTURE') {
		return <FaceCapture />
	}

	return (
		<PageWrapper>

			<Header text={"ยืนยันตัวตน e-KYC"} />

			<Container 
				className="app-container"
			>
				<ProcessingOverlay 
					pending={pending}
					global
				/>
				<h6 
					className='app-instruction-title-h6'
				>
					ตรวจสอบข้อมูลให้ตรงกับบัตรประชาชน
				</h6>
				<div 
					className="field-completed"
					style={{display: showCorrectTips ? 'flex' : 'none'}}
				>
					<img src={correctIcon} alt='' />
					<span>ระบบกรอกข้อมูลให้อัตโนมัติแล้ว คุณสามารถแก้ไขข้อมูล หากไม่ถูกต้อง</span>
				</div>

				<Row
					style={{
						alignItems: 'flex-start'
					}}
				>
					<Col md={6} className='no-padding-col'>
						<Form.Group className="field">
							<Form.Label>
								เลขบัตรประชาชน
								<i className='required'>*</i>
							</Form.Label>
							<Form.Control
								value={form.id}
								onChange={(e) => {
									setHasInteracted(true)
									handlePatternChange(
										e,
										formatRule.idcardRule.pattern,
										"id",
										form,
										setForm
									)
								}
									
								}
								placeholder={formatRule.idcardRule.pattern}
								className={showError('id') ? 'error-tips' : ''}
							/>
							<Error 
								text={
									showError('id')
										? 'ระบุเลขที่บัตรประชาชน'
										: ''
								} 
							/>
							
						</Form.Group>
					</Col>
				</Row>

				<Row
					style={{
						alignItems: 'flex-start'
					}}
				>
					<Col md={4} className='no-padding-col'>
						<Form.Group className="field">
							<Form.Label>
								ชื่อ ตามบัตรประชาชน
								<i className='required'>*</i>
							</Form.Label>
							<Form.Control
								value={form.firstName}
								onChange={(e) => {
										setHasInteracted(true)
										setForm({ ...form, firstName: e.target.value })
									}
								}
								className={showError('firstName') ? 'error-tips' : ''}
							/>
							<Error 
								text={
									showError('firstName')
										? 'ระบุชื่อที่ตรงกับบัตรประชาชนของผู้เอาประกัน' 
										: ''
								} 
							/>
						</Form.Group>
					</Col>

					<Col md={4} className='no-padding-col margin-bottom'>
						<Form.Group className="field">
							<Form.Label>ชื่อกลาง (ถ้ามี)</Form.Label>
							<Form.Control
								value={form.middleName || ''}
								onChange={(e) =>
									setForm({ ...form, middleName: e.target.value })
								}
							/>
							{/* <Error text={error('middleName') ? 'middlename' : ''} /> */}
						</Form.Group>
					</Col>

					<Col md={4} className='no-padding-col'>
						<Form.Group className="field">
							<Form.Label> 
								นามสกุล ตามบัตรประชาชน
								<i className='required'>*</i>
							</Form.Label>
							<Form.Control
								value={form.lastName}
								onChange={(e) => {
									setHasInteracted(true)
									setForm({ ...form, lastName: e.target.value  })
								}}
								// onBlur={() => handleBlur('lastName')}

								className={
									showError('lastName')
										? "error-tips"
										: ""
								}

							/>
							<Error 
								text={
									showError('lastName')
										? 'ระบุนามสกุลที่ตรงกับบัตรประชาชนของผู้เอาประกัน' 
										: ''
								} 
							/>
						</Form.Group>
					</Col>
				</Row>


        <Row>
          <Col md={6} className='no-padding-col'>
            <Form.Group
							style={{
								fontSize: '16px'
							}}
						>
              <Form.Label>
								เพศ	
								<i className='required'>*</i>
							</Form.Label>

              <div className="gender-group">

								{genderOptions.map((item) => (
									<div
										key={item.value}
										className={`form-control gender-btn ${
											form.gender === item.value ? "active" : ""
										}`}
										onClick={() => selectGender(item.value)}
									>
										<GenderIcon icon={item.icon} />
										{item.label}
									</div>
								))}

              </div>

              {/* {error('gender') && <Error />} */}
							
            </Form.Group>
          </Col>
        </Row>
					
				{/* DOB + LASER  */}
				<Row
					style={{
						alignItems: 'flex-start'
					}}
				>
					<Col md={6} className='no-padding-col'>
						<Form.Group className="field">
							<Form.Label> 
								วัน/เดือน/ปีเกิด (พ.ศ.)
								<i className='required'>*</i>
								<HelpIcon onClick={() => openModal("dobExample")} />
							</Form.Label>
							
							
							
							<BirthdayField
								value={form.dob}
								onChange={(e) => {
									setHasInteracted(true)
									setForm({ ...form, dob: e.target.value })
								}}
								// onBlur={() => handleBlur("dob")}
								error={showError('dob')}
							/>

							<Error
								text={
									showError('dob')
										? "ระบุวันเดือนปีเกิดที่ตรงกับบัตรประชาชนของผู้เอาประกัน"
										: ""
								}
							/>

						</Form.Group>
					</Col>

					<Col md={6} className='no-padding-col'>
						<Form.Group className="field">
							<Form.Label> 
								รหัสหลังบัตรประชาชน
								<i className='required'>*</i>
								<HelpIcon onClick={() => openModal("laserExample")} />
							</Form.Label>

							<Form.Control
								value={form.laser}
								// onBlur={() => handleBlur('laser')}
								onChange={(e) => {
									setHasInteracted(true)
									handlePatternChange(
										e,
										formatRule.laserRule.pattern,
										"laser",
										form,
										setForm
									)
								}}
								className={`form-control ${showError('laser') ? 'error-tips' : ''}`}
								placeholder={formatRule.laserRule.pattern}
							/>

							<Error 
								text={
									showError('laser')
									? 'กรอกเลขที่หลังบัตรประชาชน'
									: ''
								}
							/>
						</Form.Group>
					</Col>
				</Row>

				<hr className="app-divider" />

				<div className="agreement-section">
					<div
						style={{
							marginBottom: '10px',
						}}
					>
						กรุณาเลื่อนอ่านรายละเอียดก่อนให้ความยินยอม
					</div>
					<label className="check-row">
						<input
							type="checkbox"
							checked={form.agree}
							onChange={(e) =>
								setForm({ ...form, agree: e.target.checked })
							}
							style={{
								width: '0',
							}}
						/>

						<span className="box">
							{form.agree && "✓"}
						</span>

						<span
							style={{
								fontWeight: '500',
								fontSize: '14px',
							}}
						>
							คำขอความยินยอมเพื่อการยืนยันตัวตนทางอิเล็กทรอนิกส์
							<i className='required'>*</i>
						</span>
					</label>

					<div className="agreement-container">
						<div className="agreement-box">
							<span style={{ 
								color: 'black', 
								textAlign: "left",
								margin: '0',
							}}>
								{t('PageIntroComfirmToStart.pdpaStatementTitle')}<br/>
								{t('PageIntroComfirmToStart.pdpaDetailLinkLabel')}
								<a 
									style={{ display: "inline" }}
									href="http://www.aia.co.th/th/about-aia/privacy" 
									target="_blank" rel="noopener noreferrer"
									title="http://www.aia.co.th/th/about-aia/privacy"
								>
									www.aia.co.th/th/about-aia/privacy
								</a>
							</span>
						</div>
					</div>
				</div>

				<div className="submit-wrap">
					<Button
						loading={isSubmitting}
						disabled={!form.agree || isSubmitting}
						onClick={handleSubmit}
					>
						ถัดไป
					</Button>
				</div>
						
			</Container>

			<CommonModal
				show={modal.show}
				showCloseBtn={config.showCloseBtn}
				icon={config.icon}
				onHide={handleModalOnHide}
				title={config.title}
				desc={config.desc}
				type={config.layout}
				showFooter={config.showFooter}
				confirmText={config.confirmText}
				onConfirm={() => {
					handleAction(config.action);
					setModal({show: false})
				}}
			>
				{config.content}
			</CommonModal>
			
		</PageWrapper>
	)
}

function Error({ text }) {
  return (
    <div className="error-text">
			{text ? (
				<>
					<span>
						<img
							src={alertSolid}
							alt="alert solid icon"
							style={{
								width: '15px',
								height: '15px',
							}}
						/>
					</span>
					<span>{text}</span>
				</>
			) : null}
    </div>
  )
}


function HelpIcon({ onClick }) {
  return (
    <img
      src={helpIcon}
      alt=""
      style={{ 
				cursor: "pointer", 
				marginLeft: 6,
				width: '15px',
			}}
      onClick={onClick}
    />
  );
}

function GenderIcon({icon}) {
	return (
		<img 
			src={icon} 
			alt='' 
			style={{
				paddingRight: '6px',
			}}
		/>
	)
}


			
